// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"793":"469cbfb9","901":"5ecfc82b"}[chunkId] + ".chunk.css";
};